var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewsLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.8448 17.9053C3.49226 17.5483 3.69978 17.0503 3.69978 16.1621L3.69978 2.68164C3.69978 0.97168 4.57136 0.108398 6.30623 0.108398L15.9766 0.108398C17.7198 0.108398 18.5831 0.97168 18.5831 2.68164L18.5831 15.3403C18.5831 17.0503 17.7198 17.9053 15.9766 17.9053L2.8448 17.9053ZM7.0284 5.05566L15.2711 5.05566C15.5616 5.05566 15.7857 4.82324 15.7857 4.53271C15.7857 4.25049 15.5616 4.03467 15.2711 4.03467L7.0284 4.03467C6.72957 4.03467 6.50545 4.25049 6.50545 4.53271C6.50545 4.82324 6.72957 5.05566 7.0284 5.05566ZM0.0391383 8.20166C0.0391383 7.21387 0.661697 6.64111 1.67439 6.64111L2.08113 6.64111L2.08113 15.6143C2.08113 16.2202 1.64119 16.6021 1.06013 16.6104C0.47908 16.6104 0.0391383 16.2202 0.0391383 15.6143L0.0391383 8.20166ZM7.0284 7.97754L15.2711 7.97754C15.5616 7.97754 15.7857 7.75342 15.7857 7.47119C15.7857 7.18066 15.5616 6.95654 15.2711 6.95654L7.0284 6.95654C6.72957 6.95654 6.50545 7.18066 6.50545 7.47119C6.50545 7.75342 6.72957 7.97754 7.0284 7.97754ZM12.1749 10.9077L15.2711 10.9077C15.5616 10.9077 15.7774 10.6919 15.7774 10.4097C15.7774 10.1108 15.5616 9.88672 15.2711 9.88672L12.1749 9.88672C11.8761 9.88672 11.6602 10.1108 11.6602 10.4097C11.6602 10.6919 11.8761 10.9077 12.1749 10.9077ZM7.47664 13.9375L9.55183 13.9375C10.1578 13.9375 10.523 13.5723 10.523 12.9663L10.523 10.8662C10.523 10.252 10.1578 9.88672 9.55183 9.88672L7.47664 9.88672C6.86238 9.88672 6.49715 10.252 6.49715 10.8662L6.49715 12.9663C6.49715 13.5723 6.86238 13.9375 7.47664 13.9375ZM12.1749 13.896L15.2711 13.896C15.5616 13.896 15.7774 13.6802 15.7774 13.3979C15.7774 13.1074 15.5616 12.875 15.2711 12.875L12.1749 12.875C11.8761 12.875 11.6602 13.1074 11.6602 13.3979C11.6602 13.6802 11.8761 13.896 12.1749 13.896Z",
    fill: "url(#paint0_linear_5877_876)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5877_876",
    x1: 9.31111,
    y1: 2,
    x2: 9.31111,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsLetter);
export default __webpack_public_path__ + "static/media/NewsLetter.fb9dc7e580c2b7a2125e3dc50c2f2503.svg";
export { ForwardRef as ReactComponent };